import React, { useState, useEffect } from "react";
import { Mail, CheckCircle, AlertCircle, Sparkles } from "lucide-react";
import "./newsletter.css";

export default function NewsletterSignup() {
    const [email, setEmail] = useState("");
    const [status, setStatus] = useState("idle");
    const [message, setMessage] = useState("");
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => setIsVisible(true), []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email)) {
            setStatus("error");
            setMessage("Please enter a valid email address");
            return;
        }

        setStatus("loading");

        try {
            const scriptURL = "https://script.google.com/macros/s/AKfycbw7TOuSLy0CbaiPeg-758h6P-VjtcBDb8rAInZZYNui8a-vDLRgbNHawOIYxgBpWTEUZw/exec";
            const formData = new FormData();
            formData.append("email", email);
            formData.append("timestamp", new Date().toISOString());

            const r = await fetch(scriptURL, { method: "POST", body: formData });

            if (r.ok) {
                setStatus("success");
                setMessage("Successfully subscribed! 🎉 Also join our WhatsApp community 👇");
                setEmail("");
            } else throw new Error();
        } catch (e) {
            setStatus("error");
            setMessage("Oops! Something went wrong. Try again.");
        }

        setTimeout(() => {
            setStatus("idle");
            setMessage("");
        }, 5000);
    };

    return (
        <div className="pagenews">
            <div className={`news ${isVisible ? "show" : ""}`}>
                <div className="iconWrap">
                    <Sparkles className="sparkIcon" />
                </div>

                <h1 className="title">Stay In The Loop</h1>
                <p className="sub">Ideas & opportunities delivered weekly.</p>
                <p className="desc">
                    Market research, deal highlights & exclusive unlisted opportunities.
                </p>

                <form onSubmit={handleSubmit} className="form">
                    <div className="inputWrap">
                        <Mail className="icon" />
                        <input
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            placeholder="Enter email"
                            disabled={status === "loading"}
                        />
                    </div>

                    <button type="submit" disabled={status === "loading"}>
                        {status === "loading" ? "Subscribing..." : "Subscribe Now"}
                    </button>
                </form>

                {message && (
                    <div className={`status ${status}`}>
                        {status === "success" ? <CheckCircle /> : <AlertCircle />}
                        <p>{message}</p>
                    </div>
                )}

                {status === "success" && (
                    <a
                        href="https://www.whatsapp.com/channel/0029VbAzMGIJENxxcshB5D0h"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{
                            marginTop: "10px",
                            display: "flex",
                            gap: "6px",
                            alignItems: "center",
                            justifyContent: "center"
                        }}
                    >
                        <img
                            src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg"
                            alt="whatsapp"
                            style={{ width: "20px", height: "20px" }}
                        />
                        <span>Join Our WhatsApp Community</span>
                    </a>
                )}

                <p className="privacy">
                    By subscribing you accept our <span>Privacy Policy</span>
                </p>
            </div>
        </div>
    );
}
